import {GenerateDocumentContentMessage, MessageBlockType} from 'notebook/ai-tools/NotebookAIToolsConstants';
// @ts-expect-error
import {makeDefaultItem} from 'notebook/notes/CreateOps';
import {NotePart} from 'notebook/util/NoteUtilConstants';

/**
 * Given a parsed LLM response, extract all note parts to insert.
 */
export default function getNotePartsFromNotebookContentMessage(
  message: GenerateDocumentContentMessage
): Array<NotePart> {
  return message.messageBlocks.flatMap((messageBlock) => {
    if (messageBlock.type !== MessageBlockType.CONTENT) {
      return [];
    }
    return messageBlock.partialNoteParts.map((partialNotePart) => ({
      ...makeDefaultItem(),
      ...partialNotePart,
    }));
  });
}
